<template>
    <VJoyTemplate data-testid="profile-edition-experience-resume-import-step-upload-error">
        <template #template-main>
            <VJoyWrapper justify="center">
                <MaltIllustration name="plug-unplugged--high" alt="" height="125" />
                <h2>{{ $t('profile.experience.funnel.step.empty_resume.title') }}</h2>
            </VJoyWrapper>

            <VJoyWrapper justify="center">
                <VJoyButton
                    data-testid="profile-edition-experience-resume-import-error-cta-retry"
                    :label="$t('profile.experience.funnel.step.empty_resume.cta.retry')"
                    size="small"
                    variant="secondary"
                    @click="handleClickOnFunnelRetry"
                />

                <VJoyButton
                    data-testid="profile-edition-experience-resume-import-error-cta-manual-mode"
                    :label="$t('profile.experience.funnel.step.empty_resume.cta.manual')"
                    size="small"
                    variant="main"
                    @click="handleClickOnFunnelManualMode"
                />
            </VJoyWrapper>
        </template>
    </VJoyTemplate>
</template>
<script setup lang="ts">
    import {MaltIllustration} from '#components';
    import {VJoyButton, VJoyTemplate, VJoyWrapper} from '@maltjoy/core-vue';

    const emit = defineEmits<{
        'funnel-step:retry': [];
        'funnel-step:manual-mode': [];
    }>();

    function handleClickOnFunnelManualMode() {
        emit('funnel-step:manual-mode');
    }
    function handleClickOnFunnelRetry() {
        emit('funnel-step:retry');
    }
</script>
